import React, { createContext, PropsWithChildren, useContext, useMemo } from "react";
import IPricingComposite from "../../contracts/IPricingComposite";
import evaluateDisplayPrice, { presets } from "../..";
import IResolvedPricing from "../../contracts/IResolvedPricing";
const Context = createContext<IResolvedPricing>({
  price: 0
});

/**
 * This is a temporary context for implementing the new pricing module.
 * DO NOT USE THIS
 * @deprecated
 */
export default () => useContext(Context);
interface PricingProviderProps extends PropsWithChildren {
  pricingData: IPricingComposite;
}

/**
 * This is a temporary context for implementing the new pricing module.
 * DO NOT USE THIS
 * @deprecated
 */
export const PricingProvider = ({
  pricingData,
  children
}: PricingProviderProps) => {
  const resolvedPricing = useMemo(() => evaluateDisplayPrice(pricingData, presets.comprehensiveEvaluation), [pricingData]);
  return <Context.Provider value={resolvedPricing} data-sentry-element="unknown" data-sentry-component="PricingProvider" data-sentry-source-file="index.tsx">{children}</Context.Provider>;
};